import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CcpaLegalText } from '../../component/ccpa/ccpa-legal-text';
import { isConsentFlagActive } from '@wetransfer/transfer/component/consent-manager/flags';
import Checkbox from '@wetransfer/transfer/component/form/element/checkbox';
import VerticalNav from '@wetransfer/transfer/component/navigation/verticalnav';
import { consentManager } from '@wetransfer/transfer/modules/consent-manager';
import {
  accept,
  reject,
  getCcpaCookieState,
  isCcpaAccepted,
} from '@wetransfer/transfer/modules/consent-manager/ccpa-manager';
import { track } from '@wetransfer/transfer/modules/consent-manager/tracker';
import I18n from '@wetransfer/transfer/modules/i18n';
import Privacy from '@wetransfer/transfer/modules/privacy';

import menu from './menu';

export interface Props {
  path: string;
  region: Record<string, unknown>;
}

export const CcpaPreferencesBannerExperiment = ({
  path,
  region,
}: Props): JSX.Element => {
  const ccpaCookieState = getCcpaCookieState();

  const [isCcpaChecked, setCcpaChecked] = useState(
    !isCcpaAccepted(ccpaCookieState)
  );

  useEffect(() => {
    // component mount/first load
    track({
      category: 'cmp',
      action: 'show_ccpa_panel',
    });
  }, []);

  const acceptAllTrackers = () => {
    accept();
    consentManager.acceptAll();
    Privacy.acceptTrackers();
  };

  const rejectAllTrackers = () => {
    reject();
    consentManager.rejectAll();
    Privacy.declineTrackers();
  };

  const handleCcpaOnChange = () => {
    setCcpaChecked(!isCcpaChecked);

    return isCcpaChecked ? acceptAllTrackers() : rejectAllTrackers();
  };

  return (
    <div className="ccpa-page legal--cookies row legal">
      <div className="legal__nav-col">
        <VerticalNav
          items={menu(region.country, isConsentFlagActive())}
          activeItem={path}
        />
      </div>

      <div className="ccpa-preferences__container">
        <h1 className="ccpa-preferences__title">
          {I18n.t('transfer.consent-manager.ccpa-header')}
        </h1>

        <div className="ccpa-preferences__intro">
          {I18n.t('transfer.consent-manager.ccpa-intro')}
        </div>

        <div>
          <Checkbox
            onChange={handleCcpaOnChange}
            name="ccpa-check"
            label={I18n.t('transfer.consent-manager.ccpa-donotsell')}
            checked={isCcpaChecked}
            size="small"
          />
        </div>
        <div>
          <CcpaLegalText />
        </div>
      </div>
    </div>
  );
};

interface stateProps {
  route: Record<string, unknown>;
  region: string;
  session: Record<string, unknown>;
}

const mapStateToProps = ({ route, session: { region } }: stateProps) => ({
  path: route.path,
  region,
});

export default connect(mapStateToProps)(CcpaPreferencesBannerExperiment);
